.size-warning {
    position: absolute;
    top: 82px;
    left: 16px;
    width: 200px;
}
